import { makeStyles } from '@material-ui/core';
import {Helmet} from "react-helmet";

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    overflow: 'auto'
  },
}));

function Notification() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
        <Helmet title="Notificaion"/>        
    </div>
  )
}

export default Notification;
